import { gql } from '@apollo/client';

/**
 * The Approvals review's own calls (apiserver: platform/services/changeRequests.js,
 * agentPermissions.js, approvalLinks.js; reach/services/review.js). Approving
 * reuses each screen's existing mutation.
 */

const AGENT_FIELDS = `id accountId kind action what status agentName requestedAt expiresAt decidedAt decidedBy note`;

/** One agent Ask first request (a link that no longer waits says what became of it). */
export const AGENT_ACTION_APPROVAL = gql`
  query AgentActionApproval($id: ID!) {
    agentActionApproval(id: $id) { ${AGENT_FIELDS} }
  }
`;

/** Approve (one call, 15 minutes) or decline an agent's request, with a note. */
export const DECIDE_AGENT_ACTION = gql`
  mutation DecideAgentAction($id: ID!, $approve: Boolean!, $note: String) {
    decideAgentAction(id: $id, approve: $approve, note: $note) { ${AGENT_FIELDS} }
  }
`;

/** Ask for changes on site content or a campaign: the version shown goes back to the agent. */
export const REQUEST_TINYCMS_CHANGES = gql`
  mutation RequestTinycmsChanges(
    $accountId: ID!
    $kind: String!
    $id: ID
    $workingHash: String
    $note: String
  ) {
    requestTinycmsChanges(
      accountId: $accountId
      kind: $kind
      id: $id
      workingHash: $workingHash
      note: $note
    )
  }
`;

/** Undo of the above: the item waits again. */
export const WITHDRAW_TINYCMS_CHANGE_REQUEST = gql`
  mutation WithdrawTinycmsChangeRequest($accountId: ID!, $id: ID!) {
    withdrawTinycmsChangeRequest(accountId: $accountId, id: $id)
  }
`;

/** Undo of Ask for changes on a Reach post: it waits again at the time it proposed. */
export const RESTORE_WAITING_SOCIAL_POST = gql`
  mutation RestoreWaitingSocialPost($id: ID!, $proposedTime: String!) {
    restoreWaitingSocialPost(id: $id, proposedTime: $proposedTime) {
      id
    }
  }
`;

/** Undo of a declined agent request. */
export const REOPEN_AGENT_ACTION = gql`
  mutation ReopenAgentAction($id: ID!) {
    reopenAgentAction(id: $id) {
      id
      status
    }
  }
`;

/** Which site an approval link's item is on (null: none the person can open). */
export const APPROVAL_SITE = gql`
  query ApprovalSite($kind: String!, $id: ID!) {
    approvalSite(kind: $kind, id: $id)
  }
`;

/** A site made from a template: what went in for the person and the placeholders left (New site card). */
export const TINYCMS_STARTER_REVIEW = gql`
  query TinycmsStarterReview($accountId: ID!) {
    tinycmsStarterReview(accountId: $accountId)
  }
`;
